import { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'

import Title from '@/components/common/Title'
import {
  ContentWrapper,
  Container,
  GridWrapper
} from '@/components/common/HeroWrapperWithBackground.styled'

import { useIsMobile } from '@/utils/useMobile'

import HomeHeroWrapperWithBackground from '@/components/common/HomeHeroWrapperWithBackground'

import HomeHeroWrapper from '@/components/common/HomeHeroWrapper'

import Spinner from '../../common/SpinnerPage'
import Options from '../SearchNearParking/components/Options/Options'

import { useHeroHomeLogic } from './useHeroHomeLogic'
import { OptionsWrapper, TitleWrapper } from './HeroHome.styled'

const HeroHome = ({ control }: any) => {
  const { t } = useTranslation(['home', 'popups'])
  const { isMobile } = useIsMobile()

  const { market, bg, heroTitle } = useHeroHomeLogic(t)

  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return (
      <Container heroHome={false}>
        <GridWrapper>
          <ContentWrapper>
            <Spinner />
          </ContentWrapper>
        </GridWrapper>
      </Container>
    )
  }

  const content = (
    <>
      <header>
        <TitleWrapper>
          <Title
            text={heroTitle}
            animated
            highlight={false}
            style={{
              fontSize: isMobile ? '24px' : '40px',
              color: isMobile ? '#093769' : '#FFFFFF'
            }}
            leftAligned
          />
        </TitleWrapper>
      </header>
      <OptionsWrapper>
        <Options market={market} control={control} />
      </OptionsWrapper>
    </>
  )

  return !isMobile ? (
    <HomeHeroWrapperWithBackground content={content} heroHome />
  ) : (
    <HomeHeroWrapper noPadding={false}>{content}</HomeHeroWrapper>
  )
}

export default HeroHome
